'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ua = require('./ua.js');

var _ua2 = _interopRequireDefault(_ua);

var _de = require('./de.js');

var _de2 = _interopRequireDefault(_de);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    UA: _ua2.default,
    DE: _de2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/countries-3166/lib/translation/index.js
// module id = 912
// module chunks = 1